export const WOPI_FILE_PAGE = "wopi";
export const CUSTOM_APP_WINDOW = "customAppWindow";
export const EMAIL = "email";
